"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionResultsCondensedCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const surveyHelpers_1 = require("../utils/surveyHelpers");
const CommentsCondensed_1 = require("./CommentsCondensed");
const QuestionResults_1 = require("./QuestionResults");
const QuestionResultsCondensedCard = (question, responses, anonymityLevel, applicationType, autolinkIntegrations, maxResultsCount, containerProps, showImage, renderForWeb, alwaysShowResponses, currentUserId, resultsUnavailableText) => {
    const card = CardHelper_1.CardHelper.newCard();
    if (!alwaysShowResponses &&
        !responses.some(r => r.responses.some(s => s.questionId === question.id))) {
        const cont = CardHelper_1.CardHelper.create(adaptivecards_1.Container, Object.assign({ style: adaptivecards_1.ContainerStyle.Emphasis, verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center }, (renderForWeb ? { minPixelHeight: 268 } : {})));
        cont.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: resultsUnavailableText ||
                `**No ${question.questionType === "open-ended" ? "responses" : "votes"} yet**`,
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
            color: adaptivecards_1.TextColor.Accent,
            size: adaptivecards_1.TextSize.Medium,
            wrap: true,
        }));
        if (showImage) {
            cont.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, Object.assign({ url: (0, CardHelper_1.getImageCardUrl)(resultsUnavailableText ? "RESULTS_UNAVAILABLE" : "NO_VOTES", applicationType), horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center }, (renderForWeb
                ? {
                    spacing: adaptivecards_1.Spacing.None,
                    pixelHeight: 120,
                }
                : {
                    spacing: adaptivecards_1.Spacing.Padding,
                    size: adaptivecards_1.Size.Auto,
                }))));
        }
        card.addItem(cont);
    }
    else {
        card.addItem((0, QuestionResults_1.QuestionResults)(question, responses, anonymityLevel, applicationType, {
            showTitle: false,
            maxResultsCount,
            containerProps,
            autolinkIntegrations,
            currentUserId,
        }));
    }
    const comments = (0, surveyHelpers_1.getAllResponseComments)(responses);
    if (comments.length > 0) {
        card.addItem((0, CommentsCondensed_1.CommentsCondensed)(comments, maxResultsCount, anonymityLevel, {
            spacing: adaptivecards_1.Spacing.Large,
        }));
    }
    return card;
};
exports.QuestionResultsCondensedCard = QuestionResultsCondensedCard;
//# sourceMappingURL=QuestionResultsCondensedCard.js.map